import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Modal,
  Box,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  makeStyles,
  IconButton,
  CircularProgress,
  Avatar,
  useMediaQuery,
  Theme,
} from "@material-ui/core";
import { X } from "lucide-react";
import {
  getFirstUnviewedDeletedPostAPI,
  markPostReportAsViewedAPI,
  createAppealAPI,
  getFileByIdAPI,
} from "../../api/userApi";
import { showToast } from "../../utils/toast";
import { SliderItem } from "./UniversalSlider";
import defaultAvatars from "../../assets/defaultAvatars.svg";
import { useCreatorPostStyles } from "../Main/Sidebar/MyFeed-explore/style";
import { formatPostDate } from "../../utils/timeFormatter";
import { clsx } from 'clsx';

export const useStyles = makeStyles(theme => ({
  modalSubscriptionWrapper: {
    // Wrapper for backdrop
  },
  modalWrapper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#131313",
    padding: "0px",
    width: "90%",
    maxWidth: "800px",
    maxHeight: "90vh",
    borderRadius: "12px",
    zIndex: 1401,
    boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      maxHeight: "95vh",
    },
  },
  modalWrapperAppeal: {
    width: "483px",
    maxWidth: "483px",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      maxWidth: "90%",
    },
  },
  header: {
    borderRadius: "12px 12px 0 0",
    backgroundColor: "#131313",
    padding: "20px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 16px 16px",
    },
  },
  closeButton: {
    color: "#FFFFFF",
    padding: "4px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  content: {
    flex: 1,
    color: "#fff",
    overflowY: "auto",
    backgroundColor: "#131313",
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
    },
  },
  deletedMessage: {
    color: "#fff",
    fontSize: "32px",
    fontWeight: 700,
    marginBottom: "16px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  deletedInfo: {
    color: "#FFFFFF",
    fontSize: "20px",
    lineHeight: "110%",
    marginBottom: "24px",
    textAlign: "center",
    maxWidth: "473px",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
    },
  },
  reasonText: {
    color: "#FE5A97",
    fontWeight: 600,
  },
  postInfoCard: {
    backgroundColor: "#1F1F1F",
    borderRadius: "6px",
    padding: "13px",
    marginBottom: "16px",
  },
  postHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
  },
  avatar: {
    width: "38px",
    height: "38px",
  },
  userInfo: {
    flex: 1,
  },
  fullName: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
  },
  postDescription: {
    color: "#fff",
    fontSize: "14px",
    lineHeight: "1.5",
    marginTop: "12px",
  },
  mediaContainer: {
    width: "100%",
    marginBottom: "12px",
    borderRadius: "8px",
    overflow: "hidden",
  },
  postContainer: {
    width: "280px",
    maxWidth: "280px",
    height: "auto",
    margin: "0 auto",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "200px",
      maxWidth: "200px",
      height: "auto",
    },
  },
  postMedia: {
    width: "100%",
    objectFit: "cover",
    borderRadius: "8px",
    display: "block",
  },
  postVideo: {
    width: "100%",
    objectFit: "cover",
    borderRadius: "8px",
    display: "block",
  },
  actions: {
    padding: "16px 24px 48px",
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    backgroundColor: "#131313",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 24px 0",
      flexWrap: "wrap",
    },
  },
  cancelButton: {
    color: "#fff",
    padding: "10px 24px",
    minWidth: 260,
    fontSize: "20px",
    borderRadius: "6px",
    border: "1px solid #363636",
    textTransform: "capitalize",
    backgroundColor: "#FE5A97",
    "&:hover": {
      backgroundColor: "#e04a82",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      fontSize: "14px",
      padding: "12px",
      margin: "0 auto"
    },
  },
  appealButton: {
    color: "#fff",
    padding: "10px 24px",
    minWidth: 260,
    fontSize: "20px",
    borderRadius: "6px",
    textTransform: "capitalize",
    backgroundColor: "transparent",
    border: "1px solid #FE5A97",
    "&:hover": {
      backgroundColor: "#FE5A97",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      fontSize: "14px",
      padding: "12px",
      margin: "0 auto",
      marginLeft: "auto !important"
    },
  },
  smallActionBtn: {
    minWidth: 142,
  },
  continueButton: {
    margin: "0 auto",
    color: "#fff",
    padding: "12px 24px",
    minWidth: 105,
    fontSize: "14px",
    borderRadius: "6px",
    border: "1px solid #363636",
    textTransform: "capitalize",
    backgroundColor: "#FE5A97",
  },
  createdAtBtn: {
    color: "#FFFFFFCC",
    fontSize: "10px",
    fontWeight: 400,
    marginTop: "8px",
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      fontSize: "6.9px",
    },
  },
  appealForm: {},
  appealTitle: {
    color: "#fff",
    fontSize: "24px",
    fontWeight: 700,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  appealInfo: {
    color: "#FFFFFF",
    fontSize: "16px",
    lineHeight: "1.2",
    marginBottom: "24px",
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  rulesLink: {
    textDecoration: "underline",
    cursor: "pointer",
    "&:hover": {
      color: "#e04a82",
    },
  },
  inputNoBorder: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#1F1F1F",
    },
  },
  inputLabel: {
    color: "#fff",
    marginBottom: "8px",
    fontSize: "14px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
  },
  emptyContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
    color: "#999",
  },
  myFeedPost: {
    "&.MyFeed": {
      backgroundColor: "#1F1F1F",
      padding: 12,
      width: "280px",
      maxWidth: "280px",
      height: "auto",
      maxHeight: "100%",
      margin: "0 auto",
      overflow: "hidden",
      [theme.breakpoints.down("sm")]: {
        width: "200px",
        maxWidth: "200px",
        height: "auto",
      },
      "& .makeStyles-header-156": {
        padding: "0 !important",
      },
    },
  },
  modalAvatar: {
    width: "38px !important",
    height: "38px !important",
    [theme.breakpoints.down("sm")]: {
      width: "27px !important",
      height: "27px !important",
    },
  },
  modalFullName: {
    fontSize: "12px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "8px !important",
    },
  },
  modalUsername: {
    fontSize: "12px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "8px !important",
    },
  },
}));

interface PostReport {
  _id: string;
  postId: string;
  reason: string;
  comment?: string;
  status: string;
  post?: {
    _id: string;
    description?: string;
    content?: Array<{
      _id: string;
      mediaUrl: string;
      type: string;
      paidContent?: boolean;
      isBlurred?: boolean;
    }>;
    hashtags?: string[];
    user?: {
      _id: string;
      username: string;
      firstName?: string;
      lastName?: string;
      profileImg?: string;
    };
  };
  postOwner?: {
    _id: string;
    username: string;
    firstName?: string;
    lastName?: string;
    profileImg?: string;
  };
  reporter?: {
    _id: string;
    username: string;
    firstName?: string;
    lastName?: string;
    profileImg?: string;
  };
  createdAt: string;
}

interface DeletedPostModalProps {
  open: boolean;
  onClose: () => void;
}

const DeletedPostModal: React.FC<DeletedPostModalProps> = ({
  open,
  onClose,
}) => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const myFeedClasses = useCreatorPostStyles();
  const [loading, setLoading] = useState(false);
  const [postReport, setPostReport] = useState<PostReport | null>(null);
  const [showAppealForm, setShowAppealForm] = useState(false);
  const [appealComment, setAppealComment] = useState("");
  const [submittingAppeal, setSubmittingAppeal] = useState(false);
  const [mediaUrls, setMediaUrls] = useState<{ [key: string]: string }>({});
  const [loadingMedia, setLoadingMedia] = useState<{
    [key: string]: boolean;
  }>({});
  const fetchedUrlsRef = useRef<Set<string>>(new Set());

  // Fetch media URL - same approach as modal-post
  const fetchMediaUrl = useCallback(
    async (mediaUrl: string, type: string = "image") => {
      if (!mediaUrl || typeof mediaUrl !== "string") {
        setLoadingMedia(prev => ({ ...prev, [mediaUrl]: false }));
        return defaultAvatars;
      }
      // Якщо це Google URL (lh3.googleusercontent.com), використовуємо його напряму
      if (mediaUrl.includes("lh3.googleusercontent.com")) {
        setLoadingMedia(prev => ({ ...prev, [mediaUrl]: false }));
        setMediaUrls(prev => ({ ...prev, [mediaUrl]: mediaUrl }));
        return mediaUrl;
      }
      // If it's a direct link (https:// or http://), use it directly
      if (mediaUrl.startsWith("https://") || mediaUrl.startsWith("http://")) {
        setLoadingMedia(prev => ({ ...prev, [mediaUrl]: false }));
        setMediaUrls(prev => ({ ...prev, [mediaUrl]: mediaUrl }));
        return mediaUrl;
      }
      const fileId = mediaUrl.split("/api/files/")[1];
      if (!fileId) {
        setLoadingMedia(prev => ({ ...prev, [mediaUrl]: false }));
        return defaultAvatars;
      }

      setLoadingMedia(prev => ({ ...prev, [mediaUrl]: true }));
      try {
        const blobUrl = await getFileByIdAPI(fileId);
        setMediaUrls(prev => ({ ...prev, [mediaUrl]: blobUrl }));
        return blobUrl;
      } catch (err) {
        console.error(`Error fetching ${type} for ${mediaUrl}:`, err);
        return defaultAvatars;
      } finally {
        setLoadingMedia(prev => ({ ...prev, [mediaUrl]: false }));
      }
    },
    []
  );

  // Fetch first unviewed deleted post
  const fetchUnviewedPost = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getFirstUnviewedDeletedPostAPI();
      if (response.success && response.data) {
        setPostReport(response.data);
        // Load media URLs - same approach as modal-post
        if (response.data.post?.content) {
          response.data.post.content.forEach(
            (item: { _id: string; mediaUrl: string; type: string }) => {
              if (item.mediaUrl && !fetchedUrlsRef.current.has(item.mediaUrl)) {
                fetchedUrlsRef.current.add(item.mediaUrl);
                fetchMediaUrl(item.mediaUrl, item.type);
              }
            }
          );
        }
        // Load avatar for postOwner
        if (
          response.data.postOwner?.profileImg &&
          !fetchedUrlsRef.current.has(response.data.postOwner.profileImg)
        ) {
          fetchedUrlsRef.current.add(response.data.postOwner.profileImg);
          fetchMediaUrl(response.data.postOwner.profileImg, "avatar");
        }
        // Load avatar for reporter if exists
        if (
          response.data.reporter?.profileImg &&
          !fetchedUrlsRef.current.has(response.data.reporter.profileImg)
        ) {
          fetchedUrlsRef.current.add(response.data.reporter.profileImg);
          fetchMediaUrl(response.data.reporter.profileImg, "avatar");
        }
      } else {
        setPostReport(null);
      }
    } catch (error: any) {
      console.error("Error fetching unviewed post:", error);
      setPostReport(null);
    } finally {
      setLoading(false);
    }
  }, [fetchMediaUrl]);

  // Mark as viewed when closing
  const handleClose = async () => {
    if (postReport && !showAppealForm) {
      try {
        await markPostReportAsViewedAPI(postReport._id);
      } catch (error) {
        console.error("Error marking post as viewed:", error);
      }
    }
    setShowAppealForm(false);
    setAppealComment("");
    setPostReport(null);
    setMediaUrls({});
    fetchedUrlsRef.current.clear();
    onClose();
  };

  // Handle appeal form
  const handleShowAppealForm = () => {
    setShowAppealForm(true);
  };

  const handleCancelAppeal = () => {
    setShowAppealForm(false);
    setAppealComment("");
  };

  const handleSubmitAppeal = async () => {
    if (!postReport || !appealComment.trim()) {
      showToast("Please provide a comment for your appeal", "error");
      return;
    }
    try {
      setSubmittingAppeal(true);
      const response = await createAppealAPI(
        postReport.postId,
        "post",
        "Appeal",// Default reason
        appealComment.trim()
      );
      if (response.success) {
        showToast("Appeal submitted successfully", "success");
        // Mark as viewed after appeal submission
        try {
          await markPostReportAsViewedAPI(postReport._id);
        } catch (error) {
          console.error("Error marking post as viewed:", error);
        }
        handleClose();
      } else {
        showToast(response.message || "Failed to submit appeal", "error");
      }
    } catch (error: any) {
      showToast(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit appeal",
        "error"
      );
    } finally {
      setSubmittingAppeal(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchUnviewedPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const sliderItems: SliderItem[] =
    postReport?.post?.content?.map((item, index) => {
      const displayUrl =
        mediaUrls[item.mediaUrl] || item.mediaUrl || defaultAvatars;
      return {
        id: item._id,
        originalMediaUrl: item.mediaUrl,
        mediaUrl: displayUrl,
        type: item.type === "video" ? "video" : "image",
        isBlurred: false,
      };
    }) || [];

  // Get avatar URL - prefer postOwner, fallback to reporter
  const ownerForDisplay = postReport?.postOwner || postReport?.reporter;
  const avatarUrl = ownerForDisplay?.profileImg
    ? mediaUrls[ownerForDisplay.profileImg] ||
    ownerForDisplay.profileImg ||
    defaultAvatars
    : defaultAvatars;

  return (
    <Modal
      open={open}
      disablePortal
      disableEnforceFocus
      disableScrollLock
      BackdropProps={{
        onClick: handleClose,
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
      className={classes.modalSubscriptionWrapper}
    >
      <Box
        className={`${classes.modalWrapper} ${showAppealForm ? classes.modalWrapperAppeal : ""
          }`}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
        }}
      >
        {/* Header */}
        <Box className={classes.header}>
          {showAppealForm ? (
            <Typography className={classes.appealTitle}>
              Fill an appeal
            </Typography>
          ) : (
            <Box />
          )}
          <IconButton
            onClick={handleClose}
            className={classes.closeButton}
            size="small"
          >
            <X size={24} />
          </IconButton>
        </Box>

        <DialogContent className={classes.content}>
          {loading ? (
            <Box className={classes.loadingContainer}>
              <CircularProgress />
            </Box>
          ) : !postReport ? (
            <Box className={classes.emptyContainer}>
              <Typography variant="h6" style={{ color: "#999" }}>
                No deleted posts to review
              </Typography>
            </Box>
          ) : showAppealForm ? (
            <Box className={classes.appealForm}>
              <Typography className={classes.appealInfo}>
                Think your post was removed by mistake? We’ll review it again and restore if it doesn’t violate{" "}
                <span
                  className={classes.rulesLink}
                  onClick={() => {
                    handleClose();
                    window.location.href = "/terms-of-service";
                  }}
                >
                  our rules
                </span>
                .
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                value={appealComment}
                onChange={e => setAppealComment(e.target.value)}
                placeholder="Explain why your post should be restored, and we’ll take another look"
                className={classes.inputNoBorder}
                InputProps={{
                  style: {
                    color: "#fff",
                    backgroundColor: "#1F1F1F",
                    fontSize: "16px",
                    border: "1px solid #747474",
                    borderRadius: "8px",
                  },
                }}
                InputLabelProps={{ style: { color: "#fff" } }}
                inputProps={{ maxLength: 200 }}
              />
              <Typography
                variant="caption"
                style={{ color: "#FFFFFFCC", marginTop: 4, textAlign: "right" }}
              >
                {appealComment.length}/200 characters
              </Typography>
            </Box>
          ) : (
            <>
              {/* Post Content - like my-feed */}
              <Box
                className={`${myFeedClasses.root} MyFeed ${classes.myFeedPost}`}
                style={{ marginBottom: "24px" }}
              >
                <Box className={myFeedClasses.header} style={{ padding: 0 }}>
                  <Box
                    display="flex"
                    alignItems="center"
                  >
                    {loadingMedia[ownerForDisplay?.profileImg || ""] ? (
                      <Box
                        className={`${myFeedClasses.avatar} ${classes.modalAvatar}`}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress size={24} />
                      </Box>
                    ) : (
                      <Avatar
                        src={avatarUrl}
                        className={`${myFeedClasses.avatar} ${classes.modalAvatar}`}
                        onError={e => {
                          (e.target as HTMLImageElement).src = defaultAvatars;
                        }}
                      />
                    )}
                    <Box className={myFeedClasses.nameUserLastName}>
                      <Typography
                        className={`${myFeedClasses.firstLastNameHelp} ${classes.modalFullName}`}
                      >
                        {postReport.postOwner?.firstName || ""}{" "}
                        {postReport.postOwner?.lastName || ""}
                      </Typography>
                      <Typography
                        className={`${myFeedClasses.username} ${classes.modalUsername}`}
                      >
                        @{postReport.postOwner?.username || ""}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Media Container */}
                {sliderItems.length > 0 && (
                  <Box className={myFeedClasses.mediaContainer}>
                    {sliderItems.map((item, index) => {
                      const originalMediaUrl =
                        postReport?.post?.content?.[index]?.mediaUrl || "";
                      const isLoading = loadingMedia[originalMediaUrl];
                      const displayUrl =
                        mediaUrls[originalMediaUrl] ||
                        item.mediaUrl ||
                        defaultAvatars;

                      return (
                        <Box
                          key={item.id}
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {isLoading ? (
                            <Box
                              className={classes.postMedia}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#1a1a1a",
                              }}
                            >
                              <CircularProgress size={40} />
                            </Box>
                          ) : item.type === "video" ? (
                            <video
                              src={displayUrl}
                              className={classes.postVideo}
                              controls
                            />
                          ) : (
                            <img
                              src={displayUrl}
                              alt={`Post content ${index + 1}`}
                              className={classes.postMedia}
                              onError={e => {
                                (e.target as HTMLImageElement).src =
                                  defaultAvatars;
                              }}
                            />
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                )}

                {/* Description */}
                {postReport.post?.description && (
                  <Box>
                    <Typography
                      className={`${myFeedClasses.username} ${classes.modalUsername}`}
                    >
                      @{postReport.postOwner?.username || ""}
                    </Typography>
                    <Typography
                      style={{
                        color: "#fff",
                        fontSize: "10px",
                        lineHeight: "1.5",
                      }}
                    >
                      {postReport.post.description}
                    </Typography>

                    {/* Hashtags */}
                    {postReport.post?.hashtags &&
                      postReport.post.hashtags.length > 0 && (
                        <Box>
                          <Box
                            display="flex"
                            flexWrap="wrap"
                            style={{ gap: "4px" }}
                          >
                            {postReport.post.hashtags.map((tag, index) => (
                              <Typography
                                key={index}
                                variant="body2"
                                style={{
                                  color: "#FFFFFF",
                                  fontSize: "10px",
                                }}
                              >
                                #{tag}
                              </Typography>
                            ))}
                          </Box>
                        </Box>
                      )}

                    {postReport.createdAt && (
                      <Typography
                        className={classes.createdAtBtn}
                      >
                        {formatPostDate(postReport.createdAt)}
                      </Typography>
                    )}
                  </Box>
                )}

              </Box>

              {/* Deleted Message - only for first tab */}
              <Typography className={classes.deletedMessage}>
                Your post was deleted
              </Typography>
              <Typography className={classes.deletedInfo}>
                This post was taken down for violating our rules.
                Reason: {postReport?.reason || ""}
                <br />
                <br />
                If you think it was removed in error, you can appeal the
                decision and our team will take another look.
              </Typography>
            </>
          )}
        </DialogContent>

        <DialogActions className={classes.actions}>
          {showAppealForm ? (
            <>
              <Button
                onClick={handleCancelAppeal}
                className={clsx(classes.cancelButton, classes.smallActionBtn)}
                style={{
                  border: "1px solid #FE5A97",
                  backgroundColor: "transparent",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmitAppeal}
                className={clsx(classes.appealButton, classes.smallActionBtn)}
                disabled={submittingAppeal || !appealComment.trim()}
                style={{
                  border: "1px solid #FE5A97",
                  backgroundColor: "#FE5A97",
                }}
              >
                {submittingAppeal ? "Submitting..." : "Submit"}
              </Button>
            </>
          ) : isMobile ? <>
            <Button
              onClick={handleShowAppealForm}
              className={classes.continueButton}
            >
              Continue
            </Button>
          </>
            : (
              <>
                <Button
                  onClick={handleShowAppealForm}
                  className={classes.appealButton}
                >
                  Appeal decision
                </Button>
                <Button onClick={handleClose} className={classes.cancelButton}>
                  Close
                </Button>
              </>
            )}
        </DialogActions>
      </Box>
    </Modal>
  );
};

export default DeletedPostModal;
